import { CountingLoader } from '@/shared/helpers';

export const CartLoader = new CountingLoader();
